import {fromJS} from 'immutable'
import PropTypes from 'prop-types'

import Fields from '../../../../../../shared_components/forms/v2/fields'
import validators from '../../../../../../shared_components/forms/v2/validators'

import './sharedCobrandingFields.scss'

const SharedCobrandingFields = ({cobranding}) => (
  <div className='shared-cobranding-fields'>
    <Fields.Text
      data={
        fromJS({
          id: 'cobranding-url-string',
          legend: 'Custom URL:',
          name: 'cobranding-url-string',
          value: cobranding['cobranding-url-string']
        })
      }
      validator={validators.urlStringValidator}
    />
    <div className='custom-url-string-helper-text'>
      Optional. Enter the URL slug (not full URL) used to route existing
      clients to a cobranded login screen from the client invite email.
    </div>
  </div>
)

SharedCobrandingFields.propTypes = {
  cobranding: PropTypes.object
}

export default SharedCobrandingFields
